exports.validateNumberOfEdges = function validateNumberOfEdges(numberOfEdges) {
  if (typeof numberOfEdges !== "number") {
    var ARGUMENT_TYPE = Array.isArray(numberOfEdges) ? "array" : typeof numberOfEdges;
    throw new Error("ERROR! Number of edges has to be a number but was: ".concat(ARGUMENT_TYPE));
  }

  if (numberOfEdges < 3) {
    throw new Error("ERROR! Number of edges has to be at least 3 but was: ".concat(numberOfEdges));
  }
};